import version from "./version";

export const OUTPUT_CONSOLE_VERSION = `SUPSIS Live Support Software v${version.versionStr}`;
